import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyDRDs0pwIPfS6Z2HcuI0JTTB4Dcr9uNOxY",
  authDomain: "mmgoldcloud.firebaseapp.com",
  projectId: "mmgoldcloud",
  storageBucket: "mmgoldcloud.firebasestorage.app",
  messagingSenderId: "682593325112",
  appId: "1:682593325112:web:56f7408411dcac332016cd",
  measurementId: "G-GHYZF0TNLW"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'us-central1');

export default app;
